module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "id": "lpn_xiii"
    }
  })]), _c('a', {
    attrs: {
      "id": "lpn_xiii"
    }
  }, [_c('h2', [_c('b', [_vm._v("The "), _c('i', [_vm._v("Sh’ma")])])]), _vm._v(" "), _c('p', {
    staticClass: "image1",
    staticStyle: {
      "margin-top": "50pt"
    }
  }, [_c('img', {
    attrs: {
      "alt": "imgxiiia.jpg",
      "src": "html/docimages/imgxiiia.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "5pt"
    }
  }, [_vm._v("“Sh’ma Yisra’el! "), _c('i', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ADONAI")])])]), _vm._v(" Eloheynu, "), _c('i', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ADONAI")])])]), _vm._v(" echad.")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("Hear, O Isra’el, the L"), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")])]), _vm._v(" our God, the L"), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")])]), _vm._v(" is one” (Deut. 6:4).")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _c('p', {
    staticClass: "image1",
    staticStyle: {
      "margin-top": "5pt"
    }
  }, [_c('img', {
    attrs: {
      "alt": "imgxiiib.jpg",
      "src": "html/docimages/imgxiiib.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("(Baruch shem k’vod malkhooto l’olam va’ed.)")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("(Blessed be his name whose glorious kingdom is forever and ever.)")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _c('p', {
    staticClass: "hang2"
  }, [_vm._v("And you are to love "), _c('i', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ADONAI")])])]), _vm._v(" your God with all your heart, all your being and all your resources. These words, which I am ordering you today, are to be on your heart; and you are to teach them carefully to your children. You are to talk about them when you sit at home, when you are traveling on the road, when you lie down and when you get up. Tie them on your hand as a sign, put them at the front of a headband around your forehead, and write them on the door-frames of your house and on your gates (Deut. 6:5–9)")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  })]), _c('p', {
    staticClass: "hang2"
  }, [_c('a', {
    attrs: {
      "id": "lpn_xiii"
    }
  }, [_vm._v("So if you listen carefully to my "), _c('i', [_vm._v("mitzvot")]), _vm._v(" which I am giving you today, to love "), _c('i', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ADONAI")])])]), _vm._v(" your God and serve him with all your heart and all your being; then I will give your land its rain \nat the right seasons, including the early fall rains and the late spring rains; so that you can gather in your wheat, \nnew wine and olive oil; and I will give your fields grass for your livestock; with the result that you will eat and be \nsatisfied. But be careful not to let yourselves be seduced, so that you turn aside, serving other gods and worshipping\n them. If you do, the anger of "), _c('i', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ADONAI")])])]), _vm._v(" will blaze up against you. He will shut up the sky, so that \n \n \n\n")]), _c('a', {
    attrs: {
      "id": "lpn_"
    }
  }, [_vm._v(" there will be no rain. The ground will not yield its produce, and you will quickly pass away from the good land "), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("ADONAI")])])]), _vm._v(" is giving you. Therefore, you are to store up these words of mine in your heart and in all your being; tie them on your hand as a sign; put them at the front of a headband around your forehead; teach them carefully to your children, talking about them when you sit at home, when you are traveling on the road, when you lie down and when you get up; and write them on the door-frames of your house and on your gates–so that you and your children will live long on the land "), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("ADONAI")])])]), _vm._v(" swore to your ancestors that he would give them for as long as there is sky above the earth. (Deut. 11:13–21)")])]), _c('a', {
    attrs: {
      "id": "lpn_"
    }
  }, [_c('p', {
    staticClass: "mediumspace"
  }), _c('p', {
    staticClass: "hang2"
  }, [_c('i', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ADONAI")])])]), _vm._v(" said to Moshe, “Speak to the people of Isra’el, instructing them to make, through all their generations, "), _c('i', [_vm._v("tzitziyot")]), _vm._v(" on the corners of their garments, and to put with the "), _c('i', [_vm._v("tzitzit")]), _vm._v(" on each corner a blue thread. It is to be a "), _c('i', [_vm._v("tzitzit")]), _vm._v(" for you to look at and thereby remember all of "), _c('i', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ADONAI")])])]), _vm._v("’s mitzvot and obey them, so that you won’t go around wherever your own heart and eyes lead you to prostitute yourselves; but it will help you remember and obey all my mitzvot and be holy for your God. I am "), _c('i', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ADONAI")])])]), _vm._v(" your God, who brought you out of the land of Egypt in order to be your God. I am "), _c('i', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ADONAI")])])]), _vm._v(" your God.” (Num. 15:37–41)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b484876","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/08_theshma.vue
// module id = 87
// module chunks = 0